<!-- From Dialog -->
<ng-container *ngIf="data.isDialog">
  <div cdk-focus-initial class="modal show sign-in" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-body">
        <div class="modal-content modal-bg modal-blue-bg">
          <div class="modal-header">
            <h4 class="modal-title" id="myModalLabel">{{ 'Edit Card' | translate }} </h4>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="onCloseDialog()">×</button>
          </div>
          <div class="bd-bold"></div>
          <div class="p-1rem">
            <ng-container *ngTemplateOutlet="formContent"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- Non Dialog -->
<ng-container *ngIf="!data.isDialog">
  <div class="transaction-container m-b-0">
    <ng-container *ngTemplateOutlet="formContent"></ng-container>
  </div>
</ng-container>


<ng-template #formContent>
  <!-- Form Content -->
  <form [formGroup]="form" id="bank-modal-form" name="bank-modal-form">

    <!-- Card Holder Name -->
    <div class="form-input-label mt-3">
      <p>{{ 'Card Holder Name' | translate }} </p>
    </div>
    <div class="input_container bank-acc">
      <input class="form-control form-control-sm form-input-style m-b-10" type="text" placeholder="{{ 'Enter Card Holder Name' | translate }}" [value]="userData.name" readonly />
    </div>

    <!-- Card Number -->
    <div class="form-input-label mt-3">
      <p>{{ 'Card Number' | translate }} </p>
    </div>
    <div class="input_container bank-acc">
      <input class="form-control form-control-sm form-input-style m-b-10" type="text" formControlName="card_number" [ngClass]="{'is-invalid': checkValidity && form.controls.card_number.errors }" placeholder="0000 0000 0000 0000" (keypress)="allowOnlyNumbers($event)" #cardInput>
    </div>

    <!-- Expiry Date -->
    <div class="form-input-label mt-3">
      <p>{{ 'Expiry Date' | translate }} </p>
    </div>
    <div class="input_container bank-acc">
      <input class="form-control form-control-sm form-input-style m-b-10" type="text" formControlName="expiry_date" [ngClass]="{'is-invalid': checkValidity && form.controls.expiry_date.errors }" placeholder="{{ '(MM/YY)' | translate }}" #expiryInput>
    </div>

    <!-- Save Button -->
    <ng-container *ngIf="!data.isDialog">
      <button class="btn-blue-gra m-t-15" [ngClass]="{'disabled': disabledButton || !form.valid}" [disabled]="disabledButton || !form.valid" (click)="onSubmit()">{{ 'Save' | translate }}</button>
    </ng-container>
    
    <!-- Update & Remove Button -->
    <ng-container *ngIf="data.isDialog">
      <button class="btn-blue-gra flex-fill mt-2" [ngClass]="{'disabled': disabledButton || !form.valid}" [disabled]="disabledButton || !form.valid" (click)="onSubmit()" >{{ 'UPDATE CARD' | translate }}</button>
      <button class="btn-yellow-gra flex-fill mt-2" (click)="onRemove()" >{{ 'REMOVE CARD' | translate }}</button>
    </ng-container>
    
  </form>

  <br />

  <!-- My Credit Cards Section -->
  <div class="m-b-15" *ngIf="cards.length > 0 && !data.isDialog">
    <div class="title-page-blue pl-2">
      <h3>{{ 'My Credit Cards' | translate }}</h3>
    </div>

    <div class="card-list animateFadeIn m-t-10" *ngFor="let card of cards">
      <div class="card-list-container">
        <div class="row mx-auto">
          <div class="col-2 p-0 d-flex justify-content-center">
            <img [src]="'assets/images/credit-card/' + card.card_brand + '.png'">
          </div>
          <div class="col-8 d-flex align-items-center">
            <p class="m-0">{{ card.bank_name }} &#x2022;&#x2022;&#x2022;&#x2022; &#x2022;&#x2022;&#x2022;&#x2022; &#x2022;&#x2022;&#x2022;&#x2022; {{ card.last_four }} {{ card.expiry_month }}/{{ card.expiry_year }}</p>
          </div>
          <div class="col-2 pr-0 pl-3">
            <button class="btn-blue-gra edit-button-button p-0" (click)="onEdit(card)">
              <img src="assets/images/edit.png" class="edit-button-img" alt="Button Icon">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</ng-template>

<app-swal-alert [success]="isSuccess" [message]="messages$ | async" (confirmed)="onCloseDialog(true)"></app-swal-alert>